module.exports = __webpack_public_path__ + "img/arrow.d0630dd5.svg";